
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { departments, departmentSEOData } from '../data/MetauxNonFerreuxData';

const MetauxNonFerreuxDepartments = () => {
  const groupedDepartments = departments.reduce((acc, dept) => {
    if (!acc[dept.region]) {
      acc[dept.region] = [];
    }
    acc[dept.region].push(dept);
    return acc;
  }, {} as Record<string, typeof departments>);

  return (
    <div className="bg-fabre-lightbeige p-8 rounded-lg mb-12">
      <h2 className="text-2xl font-bold text-fabre-darkgreen mb-6">
        Recyclage des Métaux Non Ferreux par Département
      </h2>
      
      <p className="mb-6 text-gray-700">
        Le Groupe Fabre Environnement propose ses services de collecte, rachat et recyclage des métaux non ferreux 
        (aluminium, cuivre, zinc, etc.) dans de nombreux départements. Nos équipes d'experts sont à votre disposition 
        pour tous vos besoins en valorisation des déchets métalliques.
      </p>

      <div className="space-y-8">
        {Object.entries(groupedDepartments).map(([region, depts]) => (
          <div key={region} className="space-y-4">
            <h3 className="text-xl font-bold text-fabre-gray">{region}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {depts.map((dept) => (
                <div key={dept.code} className="bg-white rounded-md p-4 shadow-sm border border-gray-200">
                  <h4 className="text-lg font-semibold text-fabre-gray">
                    {dept.name} ({dept.code})
                  </h4>
                  {departmentSEOData[dept.code] && (
                    <p className="text-gray-600 text-sm mt-2">
                      {departmentSEOData[dept.code].zones.slice(0, 3).join(', ')}, etc.
                    </p>
                  )}
                  <ul className="mt-3 space-y-1">
                    <li className="text-sm text-gray-700 flex items-center">
                      <ArrowRight className="h-3 w-3 text-fabre-green mr-2" />
                      Collecte des métaux non ferreux
                    </li>
                    <li className="text-sm text-gray-700 flex items-center">
                      <ArrowRight className="h-3 w-3 text-fabre-green mr-2" />
                      Rachat au meilleur prix
                    </li>
                  </ul>
                  <div className="mt-4">
                    <Link 
                      to={`/nos-services/achat-metaux/${dept.name.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
                      className="text-sm text-fabre-darkgreen hover:underline"
                    >
                      En savoir plus
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetauxNonFerreuxDepartments;
